import { useSelector } from 'react-redux';
import { Divider } from 'src/components/atoms';
import { DividerContainer } from 'src/components/molecules/InviteToCaseModal/Steps/AccessStep.styles';
import { Access } from 'src/components/molecules/InviteToCaseModal/components/Access/Access';
import { accessStepPermissionHelper } from 'src/components/molecules/InviteToCaseModal/helpers/accessStepPermissionHelper';
import { CasePermissionsType, Nullable } from 'src/types';
import { reviewCaseTeamMemberModalVM } from './ReviewCaseTeamMemberModal.vm';
import { GlobalAccessDetails } from './components/GlobalAccessDetails';
import { Note } from './components/Note';

interface EditCaseTeamMemberProps {
  userId: Nullable<number>;
  showNoteTop: boolean;
  handleEditPermissions: (
    permissions: CasePermissionsType[],
    addRemove: 'add' | 'remove',
  ) => void;
  permissions: CasePermissionsType[];
}

export const EditCaseTeamMember = ({
  userId,
  showNoteTop,
  permissions,
  handleEditPermissions,
}: EditCaseTeamMemberProps) => {
  const {
    name,
    caseDisplayId,
    caseTeamNoteText,
    canEditPermissions,
    unableToChat,
    isReportAssignee,
    isSuperAdmin,
  } = useSelector(reviewCaseTeamMemberModalVM(userId));

  const {
    hasAllViewPermissions,
    hasAllEditPermissions,
    hasSomeEditPermissions,
    disabledViewReportPII,
    disabledViewCasePII,
    ALL_VIEW_PERMISSIONS,
    ALL_EDIT_PERMISSIONS,
  } = accessStepPermissionHelper(permissions, unableToChat);

  const disableGlobalAccess = isSuperAdmin || isReportAssignee;

  const handleClickAllEditAccess = () => {
    handleEditPermissions(ALL_VIEW_PERMISSIONS, 'remove');
    handleEditPermissions(ALL_EDIT_PERMISSIONS, 'add');
  };

  const handleClickAllViewAccess = () => {
    handleEditPermissions(ALL_EDIT_PERMISSIONS, 'remove');
    handleEditPermissions(ALL_VIEW_PERMISSIONS, 'add');
  };

  return (
    <>
      {showNoteTop && caseTeamNoteText && (
        <>
          <DividerContainer>
            <Divider variant={'horizontal'} />
          </DividerContainer>
          <Note
            caseTeamNoteText={caseTeamNoteText}
            title="Attached note"
            data-testid="review-case-team-member-modal-note"
          />
        </>
      )}
      <GlobalAccessDetails
        hasAllEditPermissions={hasAllEditPermissions}
        hasSomeEditPermissions={hasSomeEditPermissions}
        hasAllViewPermissions={hasAllViewPermissions}
        overrideDisplay={true}
        disableFields={disableGlobalAccess}
        displayDivider={false}
        name={name}
        caseDisplayId={caseDisplayId}
        handleEditAccess={handleClickAllEditAccess}
        handleViewAccess={handleClickAllViewAccess}
      />
      <Access
        permissions={permissions}
        handleSetPermissions={handleEditPermissions}
        disabledViewCasePII={disabledViewCasePII}
        disabledViewReportPII={disabledViewReportPII}
        unableToChat={unableToChat}
        disablePermissions={!canEditPermissions}
        isSuperAdmin={isSuperAdmin}
        isReportAssignee={isReportAssignee}
      />
      {!showNoteTop && (
        <>
          <DividerContainer>
            <Divider variant={'horizontal'} />
          </DividerContainer>
          <Note
            caseTeamNoteText={caseTeamNoteText}
            title="Attached note"
            data-testid="review-case-team-member-modal-note"
          />
        </>
      )}
    </>
  );
};
